import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

const PRESETS = [["", "All events"], ["entity.search", "Deliberate entity searches"], ["incident.search", "History searches"], ["entity.auto_surface", "Routine auto-surfaced matches"], ["alert.", "Alert reviews"], ["comment.edit", "Comment corrections"], ["incident.", "Incident operations"], ["config.", "Configuration changes"]];

export function AuditLog() {
  const [action, setAction] = useState("entity.search");
  const [userName, setUserName] = useState("");
  const q = useQuery({ queryKey: ["audit-events", action, userName], queryFn: async () => (await api.get("/audit/events", { params: { action: action || undefined, user_name: userName || undefined, limit: 300 } })).data });
  return (
    <div className="space-y-3" data-testid="audit-log">
      <div><h2 className="display text-base font-semibold">Audit trail</h2><p className="text-xs text-muted-foreground">Deliberate PII/entity searches are recorded with who, what category/value and when. Routine auto-surfaced history is logged as normal system operation.</p></div>
      <div className="flex gap-1.5 text-xs">
        <select data-testid="audit-action-filter" className="field-input w-64" value={action} onChange={(e) => setAction(e.target.value)}>{PRESETS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
        <input data-testid="audit-user-filter" className="field-input w-56" placeholder="Filter by user" value={userName} onChange={(e) => setUserName(e.target.value)} />
        <span className="mono text-muted-foreground self-center">{q.data?.length ?? "…"} events</span>
      </div>
      <div className="rounded-xl border overflow-auto max-h-[70vh]">
        <table className="w-full text-xs text-left">
          <thead className="bg-muted/50 overline-label sticky top-0"><tr><th className="px-2 py-1.5 font-medium">When</th><th className="px-2 py-1.5 font-medium">Who</th><th className="px-2 py-1.5 font-medium">Action</th><th className="px-2 py-1.5 font-medium">Entity</th><th className="px-2 py-1.5 font-medium">Details</th></tr></thead>
          <tbody>
            {(q.data || []).map((e) => (
              <tr key={e.id} data-testid={`audit-row-${e.id}`} className={`border-t ${e.action === "entity.search" ? "bg-amber-500/5" : ""}`}>
                <td className="px-2 py-1 mono whitespace-nowrap">{fmtDateTime(e.at)}</td>
                <td className="px-2 py-1">{e.user_name}</td>
                <td className="px-2 py-1 mono">{e.action}</td>
                <td className="px-2 py-1 mono text-muted-foreground">{e.entity_type}{e.entity_id ? ` · ${e.entity_id.slice(-6)}` : ""}</td>
                <td className="px-2 py-1 mono text-[11px] text-muted-foreground max-w-[520px] truncate" title={JSON.stringify(e.details)}>{JSON.stringify(e.details)}</td>
              </tr>
            ))}
            {q.data?.length === 0 && <tr><td colSpan={5} className="px-2 py-4 text-center text-muted-foreground">No events.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
